import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';

class ItemRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
  }
  async getTypes() {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/api/item`;

    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data;
    } catch (e) {
      return [];
    }
  }
  async getItemsByIdDocumentOp(idDocument) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/operation-item?idDocument=${idDocument}`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data;
    } catch (e) {
      return [];
    }
  }
  async getItemsByIdDocument(idDocument) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/document/${idDocument}`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data.items;
    } catch (e) {
      return [];
    }
  }
  async getItems() {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/api/itemData`;

    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data;
    } catch (e) {
      console.log(e);
      return [];
    }
  }
  async getItemsPerPage(page, rowsPerPage) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/itemData?pageNum=${page}&pageSize=${rowsPerPage}`;

    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response;
    } catch (e) {
      console.log(e);
      return {
        data: [],
        paginator: {
          totalRows: 0,
        },
      };
    }
  }
}

Container.set({ id: ItemRepository, type: ItemRepository });

export default ItemRepository;
